<script>
import Panel from '@phoenix/mixins/components/common/Panel';
import { PhxIcon } from '@phx-styleguides/pia';

export default {
  components: { PhxIcon },

  mixins: [Panel],

  props: {
    tight: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: false,
    },
    noSlide: {
      type: Boolean,
      default: false,
    },
    bodyDataCy: {
      type: String,
      default: '',
    },
    bodyHeaderContainer: {
      type: Boolean,
      default: true,
    },
    hasScrollableContent: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      defaultOptions: {
        overlayClass: 'panel-overlay',
        containerClass: 'panel-body',
      },
    };
  },

  computed: {
    _classes() {
      return [
        'panel',
        {
          'panel--reversed': this.reverse,
          'panel--tight': this.tight,
          'panel--full': this.full,
          'panel--no-slide': this.noSlide,
        },
        ...this.classes,
      ];
    },

    _contentClasses() {
      return ['panel-body-content', ...this.contentClasses];
    },

    _headerClasses() {
      return [
        { 'panel-body-header': this.bodyHeaderContainer, 'panel-body-header--divided': this.headerBordered },
        ...this.headerClasses,
      ];
    },

    _footerClasses() {
      return ['panel-body-footer', { 'panel-body-footer--divided': this.footerBordered }, ...this.footerClasses];
    },
  },
};
</script>

<template>
  <div :id="id" :class="_classes" aria-hidden="true">
    <div class="panel-overlay" :data-panel-close="id" tabindex="-1"></div>

    <div class="panel-body" :data-cy="bodyDataCy">
      <div :class="_headerClasses">
        <slot name="header">
          <div v-if="hasTitle" class="panel-body-header__title h5" role="heading" aria-level="1">{{ title }}</div>

          <button
            class="btn btn--bare btn--fade btn--xs btn--icon-only"
            type="button"
            :data-panel-close="id"
            :aria-label="$t('Accessibility.button.close')"
          >
            <span class="btn__icon btn__icon--start">
              <phx-icon icon="cross" class="icon--xs" :title="$t('Accessibility.modal.close')" />
            </span>
            <span class="sr-only">{{ $t('Accessibility.button.close') }}</span>
          </button>
        </slot>
      </div>

      <div :class="_contentClasses" :data-simplebar="hasScrollableContent">
        <slot name="content"></slot>
      </div>

      <div v-if="hasFooterSlot" :class="_footerClasses">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>
